module.exports = __webpack_public_path__ + "img/icon-cellular.978701ec.svg";